import React from 'react';
import PropTypes from 'prop-types';
import { buildThumbnailUrl, SanitizeHtml } from '@bd/bdcore-utilities';

function PageIntroBanner({ h2, h3, p, background }) {
  const mediaStyle = {};
  if (background) {
    mediaStyle.backgroundImage = `url('${buildThumbnailUrl(background, { width: 1000, height: 1000 })}')`;
  }
  return (
    <div className="row m-0">
      <div className="container page-intro-header">
        <div className="row p-5">
          <div className="col-lg-10 mx-auto text-center">
            {
              h2 !== undefined &&
              <h2 dangerouslySetInnerHTML={SanitizeHtml(h2)} />
            }
            {
              h3 !== undefined &&
              <h3 className="underdog" dangerouslySetInnerHTML={SanitizeHtml(h3)} />
            }
          </div>
        </div>
      </div>
      <div className="page-intro-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-xl-5 order-xl-2 result-media-wrapper">
              <div className="result-media" style={mediaStyle} />
            </div>
            <div className="col-xl-7 order-xl-1 result-content">
              {
                p !== undefined &&
                <p dangerouslySetInnerHTML={SanitizeHtml(p)} />
              }
            </div>
          </div>
          <div className="inset-dropshadow" />
        </div>
      </div>
    </div>
  );
}

PageIntroBanner.propTypes = {
  h2: PropTypes.string.isRequired,
  h3: PropTypes.string,
  p: PropTypes.string,
  background: PropTypes.string,
};

PageIntroBanner.defaultProps = {
  background: undefined,
  h3: undefined,
  p: undefined,
};

export default PageIntroBanner;



// WEBPACK FOOTER //
// ./src/components/PageIntroBanner/index.js